import React, { Fragment } from 'react';
import { filter, find, includes, isNil, isNull, range, sortBy } from 'lodash';
import WidgetPreviewProductDetailWrap from '../../views/widget/common/widgetPreview/widgetPreviewProduct/WidgetPreviewProductDetailWrap';
import WidgetPreviewProductWrap from '../../views/widget/common/widgetPreview/widgetPreviewProduct/WidgetPreviewProductWrap';
import WidgetPreviewStoreWrap from '../../views/widget/common/widgetPreview/widgetPreviewStore/WidgetPreviewStoreWrap';
import WidgetPreviewEventWrap from '../../views/widget/common/widgetPreview/widgetPreviewEvent/WidgetPreviewEventWrap';
import WidgetPreviewBannerWrap from '../../views/widget/common/widgetPreview/widgetPreviewBanner/WidgetPreviewBannerWrap';
import { DISCOUNT_TYPE } from '../../constants/service/app/productConstants';
import { asyncSimpleModal, checkIsBetween, setNumberWithComma } from '../common';
import { DATE_FORMAT } from '../../constants/service/common/utilConstants';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import Anchor from '../../components/link/Anchor';
import Button from '../../components/Button';
import { setDateFormat } from '../moment';
import {
  ENABLE_BRAND_ITEM_CONTENTS_BRAND_LAYOUT_TYPE_LIST,
  ENABLE_BRAND_ITEM_IMG_BRAND_LAYOUT_TYPE_LIST,
  ENABLE_SEARCH_WIDGET_BANNER_ITEM_LINK_TYPE_INFO_LIST,
  MAXIMUM_NUMBER_OF_WIDGET_STORE_ITEM_CONTENT_TEXT,
  WIDGET_BANNER_SECTION_LAYOUT_INFO,
  WIDGET_BRAND_SECTION_LAYOUT_INFO,
  WIDGET_ITEM_BANNER_ATTACHMENT_TYPE,
  WIDGET_ITEM_EVENT_ATTACHMENT_TYPE,
  WIDGET_LAYOUT_TYPE,
  WIDGET_LAYOUT_TYPE_TEXT,
  WIDGET_PRODUCT_RANDOM_ITEM_COUNT_SELECT_LIST_INFO,
  WIDGET_PRODUCTION_CONDITION_TYPE,
  WIDGET_TYPE,
  WIDGET_TYPE_TEXT,
} from '../../constants/service/app/widgetConstants';
import {
  WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL,
  WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/widget/models';
import WidgetPreviewTimedealWrap from '../../views/widget/common/widgetPreview/widgetPreviewTimedeal/WidgetPreviewTimedealWrap/WidgetPreviewTimedealWrap';

/**
 *  위젯 타입에 따라서 위젯 컨텐츠 영역 설정
 */
export const setWidgetContents = (
  widgetInfo,
  selectedWidgetItemList,
  widgetDetail,
  widgetSection,
  no,
  pageType = 0,
  moveToDetailPage,
) => {
  const widgetType = widgetInfo.widgetType;

  /**
   *  위젯 타입 = 상품
   */
  if (widgetType === WIDGET_TYPE.PRODUCT) {
    return (
      <Fragment>
        {pageType === 0 ? (
          <WidgetPreviewProductWrap
            widgetInfo={widgetInfo}
            selectedWidgetItemList={selectedWidgetItemList}
            widgetSection={widgetSection}
            moveToDetailPage={moveToDetailPage}
          />
        ) : (
          <WidgetPreviewProductDetailWrap
            detailTopImg={widgetDetail.detailTopImg}
            selectedWidgetItemList={selectedWidgetItemList}
          />
        )}
      </Fragment>
    );
  } else if (widgetType === WIDGET_TYPE.BRAND) {
    /**
     *  위젯 타입 = 브랜드
     */
    return (
      <WidgetPreviewStoreWrap widgetInfo={widgetInfo} exposureWidgetItemList={widgetSection.exposureWidgetItemList} />
    );
  } else if (widgetType === WIDGET_TYPE.EVENT) {
    /**
     *  위젯 타입 = 기획전
     */
    return (
      <WidgetPreviewEventWrap
        no={no}
        widgetInfo={widgetInfo}
        exposureWidgetItemList={widgetSection.exposureWidgetItemList}
      />
    );
  } else if (widgetType === WIDGET_TYPE.TIME_DEAL) {
    /**
     *  위젯 타입 = 기획전
     */
    return (
      <WidgetPreviewTimedealWrap
        widgetInfo={widgetInfo}
        exposureWidgetItemList={widgetSection.exposureWidgetItemList}
      />
    );
  }
  /**
   *  위젯 타입 = 배너
   */
  return (
    <WidgetPreviewBannerWrap widgetInfo={widgetInfo} exposureWidgetItemList={widgetSection.exposureWidgetItemList} />
  );
};

/**
 *  위젯 상품 조건에 따른 상품 유효성 체크
 *  상품이 유효하지 않다면 항목에 invalid : true 속성을 추가함
 */
export const setWidgetProductCondition = (list, condition) => {
  const updateList = list.map((item) => {
    let invalid = false;
    /**
     *  위젯 상품 조건 타입이 실판매가인 경우
     */
    if (condition.type === WIDGET_PRODUCTION_CONDITION_TYPE.REAL_PRICE) {
      /**
       *  실판매가가 최소값보다 낮고, 최대값보다 큰 경우에는 유효하지 않음으로 판정
       */
      if (item.salesPrice < condition.minValue || item.salesPrice > condition.maxValue) {
        invalid = true;
      }
    } else {
      /**
       *  위젯 상품 조건 타입이 할인가인 경우
       */
      /**
       *  할인이 설정이 되어 있지 않을 경우에는 유효하지 않음으로 판정
       */
      if (isNil(item.discountPrice) || isNil(item.discountRate)) {
        invalid = true;
      }

      /**
       *  상품의 할인 기간이 무기한이 아닐경우
       *  현재 시점에서 유효한지 체크해야함
       */
      if (
        !isNull(item.discountStartDate) &&
        !isNull(item.discountEndDate) &&
        !checkIsBetween(DATE_FORMAT.YMD_DASH_FORMAT, item.discountStartDate, item.discountEndDate)
      ) {
        invalid = true;
      }

      /**
       *  할인 방법이 할인양인 경우
       */
      if (condition.discountType === DISCOUNT_TYPE.FIXED_AMOUNT_DISCOUNT) {
        /**
         *  할인양이 최소값보다 낮고, 최대값보다 큰 경우에는 유효하지 않음으로 판정
         */
        if (item.discountPrice < condition.minValue || item.discountPrice > condition.maxValue) {
          invalid = true;
        }
      } else if (condition.discountType === DISCOUNT_TYPE.FIXED_RATE_DISCOUNT) {
        /**
         *  할인 방법이 할인율인 경우
         */
        /**
         *  할인율이 최소값보다 낮고, 최대값보다 큰 경우에는 유효하지 않음으로 판정
         */
        if (item.discountRate < condition.minValue || item.discountRate > condition.maxValue) {
          invalid = true;
        }
      }
    }

    return {
      ...item,
      invalid,
    };
  });

  return sortBy(updateList, (item) => !item.invalid);
};

/**
 *  위젯 아이템 유효성 체크
 */
export const setFilterValidWidgetItem = (widgetItemList) => {
  return filter(widgetItemList, (item) => !item.invalid);
};

/**
 *  위젯 아이템 유효성 데이터 삭제하기
 */
export const deleteValidProperty = (list) => {
  return list.map((item) => {
    delete delete item.invalid;
    return item;
  });
};

/**
 *  위젯 아이템 링크 ID 설정
 */
export const setWidgetItemLinkId = (widgetItemIndex, linkType, linkId, toggleModal, name) => {
  /**
   * 링크 ID 를 선택하는 모달이 필요한 링크 타입 체크(링크 타입이 브랜드(1), 기획전(2), 상품 상세(16), 후기 상세(17), 태그 상세(19,20) 일경우)
   */
  const needSearchModalData = find(
    ENABLE_SEARCH_WIDGET_BANNER_ITEM_LINK_TYPE_INFO_LIST,
    (item) => item.id === linkType,
  );

  /**
   * 링크 ID 를 선택하는 모달이 필요한 링크인 경우에는
   * 링크 ID 를 선택할 수 있는 모달을 열수 있는 버튼을 만들어야 함
   */
  if (needSearchModalData) {
    /**
     * 검색하는 모달의 widgetType 이 있다면 filterOption, sortOption 을 추가하기
     */
    const optionData = {};

    /**
     *  필터 옵션
     */
    if (WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL[linkType]) {
      optionData.filterOption = WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL[linkType];
    }

    /**
     *  정렬 옵션
     */
    if (WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL[linkType]) {
      optionData.sortOption = WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL[linkType];
    }

    /**
     * 링크 ID 를 선택할 수 있는 모달에 넣어줄 DATA SET 만들기
     */
    const setData = (linkId) => {
      return {
        name: needSearchModalData.targetModal,
        data: {
          /**
           * 변경해야 할 STORE PATH
           */
          targetPath: ['widgetSave', 'exposureWidgetItemList', 'list', widgetItemIndex],
          /**
           * 리스트를 받아오는 STORE PATH
           */
          listPath: [needSearchModalData.targetModal, 'data', 'listData'],
          listData: {
            list: [],
            ...optionData,
            pagination: LIST_PAGINATION_MODEL,
          },
          selectedId: linkId,
          linkType,
          attachment: [],
        },
        value: true,
      };
    };

    /**
     * 링크 ID 가 선택되어졌을 경우에는 편집을 할 수 있도록 함
     */
    if (linkId && needSearchModalData) {
      return (
        <Anchor isUnderLine color="primary" onClick={() => toggleModal(setData(linkId))} text={`${name}(${linkId})`} />
      );
    } else if (needSearchModalData) {
      /**
       * 링크 ID 를 선택 할 수 있도록 하는 모달을 열 수 있는 버튼을 만듦
       */
      return <Button text="ID 선택" color="primary" onClick={() => toggleModal(setData(null))} />;
    }
  } else return '-';
  /**
   * 링크 ID 를 선택하지 않은 링크 타입인 경우에는
   * - 으로 보여주고 등록을 하게 되었을 때,
   * DB 의 Banner.linkId 컬럼에는 null 로 저장이 됨
   */
};

/**
 *  위젯 노출기간 설정하기
 */
export const setWidgetExposurePeriod = (startDate, endDate) => {
  return startDate && endDate
    ? `${setDateFormat(startDate, DATE_FORMAT.FULL_DASH_FORMAT)} ~ ${setDateFormat(
        endDate,
        DATE_FORMAT.FULL_DASH_FORMAT,
      )}`
    : '무기한';
};

/**
 *  랜덤시 노출할 수 있는 위젯 상품 개수 SELECT LIST 설정하기
 */
export const setWidgetProductRandomItemCountSelectList = (layoutType) => {
  const targetSelectListInfo = WIDGET_PRODUCT_RANDOM_ITEM_COUNT_SELECT_LIST_INFO[layoutType];

  const exposureItemCountSelectList = range(targetSelectListInfo.RANGE).map((item, index) => {
    const targetValue = targetSelectListInfo.MIN_VALUE + index * targetSelectListInfo.UNIT_COUNT;
    return {
      id: targetValue,
      name: setNumberWithComma(targetValue, '개'),
    };
  });

  return exposureItemCountSelectList;
};

/**
 *  브랜드/배너 위젯 레이아웃 변경시 위젯 아이템 개수 체크
 */
export const checkBrandAndBannerWidgetSelectedWidgetItemCount = async (
  widgetType,
  layoutType,
  selectedWidgetItemCount,
) => {
  let maximumNumberOfWidgetItem;
  if (widgetType === WIDGET_TYPE.BRAND) {
    maximumNumberOfWidgetItem = WIDGET_BRAND_SECTION_LAYOUT_INFO[layoutType].MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT;
  } else if (widgetType === WIDGET_TYPE.BANNER) {
    maximumNumberOfWidgetItem = WIDGET_BANNER_SECTION_LAYOUT_INFO[layoutType].MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT;
  }
  if (selectedWidgetItemCount > maximumNumberOfWidgetItem) {
    await asyncSimpleModal({
      type: 'error',
      title: `위젯 ${WIDGET_TYPE_TEXT[widgetType]} 아이템 개수 초과`,
      message: `현재 선택된 위젯 ${WIDGET_TYPE_TEXT[widgetType]} 아이템 개수는 ${selectedWidgetItemCount}입니다. 
                    변경하실 위젯 ${WIDGET_TYPE_TEXT[widgetType]} (${WIDGET_LAYOUT_TYPE_TEXT[widgetType][layoutType]}) 아이템 개수는 
                    최대 ${maximumNumberOfWidgetItem} 입니다.
                    ${WIDGET_TYPE_TEXT[widgetType]} 아이탬 개수를 ${maximumNumberOfWidgetItem}개 이하로 설정하시고 변경하십시오.`,
    });
    return false;
  }
  return true;
};

/**
 *  위젯 미리보기 데이터 설정하기
 */
export const setPreviewWidgetData = (
  widgetInfo,
  selectedWidgetItemList,
  exposureWidgetItemList,
  widgetProductTypeInfo,
  widgetDetail,
) => {
  let updatedExposureWidgetItemList = [...exposureWidgetItemList.list];
  let updatedSelectedWidgetItemList = [...selectedWidgetItemList];

  /**
   *  위젯 타입이 상품(0) 이고,
   *  위젯 상품 조건이 설정되어 있을 경우
   *  위젯 아이템에 상품 조건을 적용함
   */
  if (
    widgetInfo.widgetType === WIDGET_TYPE.PRODUCT &&
    widgetProductTypeInfo.productCondition &&
    widgetProductTypeInfo.isUsedProductCondition
  ) {
    updatedExposureWidgetItemList = setWidgetProductCondition(
      updatedExposureWidgetItemList,
      widgetProductTypeInfo.productCondition,
    );
    updatedSelectedWidgetItemList = setWidgetProductCondition(
      updatedSelectedWidgetItemList,
      widgetProductTypeInfo.productCondition,
    );
  } else if (widgetInfo.widgetType === WIDGET_TYPE.BRAND) {
    /**
     *  위젯 타입이 브랜드(1) 이고,
     *  위젯 레이아웃 티압이 그리드 1 X 4 인 경우에는
     *  title 에 storeName 을 넣어줌
     */
    updatedExposureWidgetItemList = updatedExposureWidgetItemList.map((item) => ({
      id: item.id,
      url: includes(ENABLE_BRAND_ITEM_IMG_BRAND_LAYOUT_TYPE_LIST, widgetInfo.layoutType)
        ? item.img[0] && item.img[0].url
          ? item.img[0].url
          : ''
        : item.url,
      title: widgetInfo.layoutType === WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_1_X_4 ? item.storeName : item.title,
      contents: includes(ENABLE_BRAND_ITEM_CONTENTS_BRAND_LAYOUT_TYPE_LIST, widgetInfo.layoutType)
        ? item.contents
        : null,
    }));
  } else if (widgetInfo.widgetType === WIDGET_TYPE.EVENT) {
    /**
     *  위젯 타입이 기획전(2) 인 경우
     */
    updatedExposureWidgetItemList = updatedExposureWidgetItemList.map((item) => ({
      ...item,
      url:
        item.img[WIDGET_ITEM_EVENT_ATTACHMENT_TYPE.APP][0] && item.img[WIDGET_ITEM_EVENT_ATTACHMENT_TYPE.APP][0].url
          ? item.img[WIDGET_ITEM_EVENT_ATTACHMENT_TYPE.APP][0].url
          : '',
    }));
  } else if (widgetInfo.widgetType === WIDGET_TYPE.BANNER) {
    /**
     *  위젯 타입이 배너(3) 인 경우
     */
    updatedExposureWidgetItemList = updatedExposureWidgetItemList.map((item) => ({
      ...item,
      url:
        item.img[WIDGET_ITEM_BANNER_ATTACHMENT_TYPE.APP][0] && item.img[WIDGET_ITEM_BANNER_ATTACHMENT_TYPE.APP][0].url
          ? item.img[WIDGET_ITEM_BANNER_ATTACHMENT_TYPE.APP][0].url
          : '',
    }));
  }

  return {
    /**
     *  위젯 정보
     */
    widgetInfo: {
      /**
       *  위젯 식별 id
       */
      widgetId: widgetInfo.widgetId,
      /**
       *  위젯 데이터 타입
       */
      widgetType: widgetInfo.widgetType,
      /**
       *  위젯 레이아웃 타입
       */
      layoutType: widgetInfo.layoutType,
      /**
       *  위젯 타이틀
       */
      mainTitle: widgetInfo.mainTitle,
      /**
       *  위젯 서브 타이틀 사용유무
       */
      isUsedSubTitle: widgetInfo.isUsedSubTitle,
      /**
       *  위젯 서브 타이틀
       */
      subTitle: widgetInfo.subTitle,
      /**
       *  위젯 버튼 사용유무
       */
      isUsedButton: widgetInfo.isUsedButton,
      /**
       *  위젯 버튼 텍스트
       */
      widgetButtonText: widgetInfo.widgetButtonText,
      /**
       *  위젯 시작시간
       */
      exposureStartDate: widgetInfo.exposureStartDate,
      /**
       *  위젯 종료시간
       */
      exposureEndDate: widgetInfo.exposureEndDate,
      /**
       * 자동 추천 위젯 여부
       */
      isProductRecommend: widgetInfo.isProductRecommend,
    },
    /**
     *  선택된 위젯 아이템 리스트
     */
    selectedWidgetItemList: updatedSelectedWidgetItemList,
    /**
     *  위젯 섹션
     */
    widgetSection: {
      /**
       *  위젯 홈 상단 이미지
       */
      topImg: widgetProductTypeInfo.productLayoutInfo.topImg,
      /**
       *  위젯 아이템 랜덤 여부
       */
      isRandomItem: widgetProductTypeInfo.productLayoutInfo.isRandomItem,
      /**
       *  위젯 아이템이 랜덤 노출일 경우
       *  노출될 위젯 아이템 개수
       */
      exposureItemCount: widgetProductTypeInfo.productLayoutInfo.exposureItemCount,
      /**
       *  홈에 노출될 위젯 아이템 리스트
       */
      exposureWidgetItemList: updatedExposureWidgetItemList,
    },
    /**
     *  위젯 상세
     */
    widgetDetail: {
      /**
       *  위젯 상세 화면 상단 이미지
       */
      detailTopImg: widgetDetail.detailTopImg,
    },
  };
};

/**
 *  위젯 브랜드 내용 최대 글자수 설정하기
 */
export const setMaximumNumberOfWidgetStoreItemContentText = (layoutType) => {
  return `*위젯 상점 아이템 내용의 글자 수는 최대 ${MAXIMUM_NUMBER_OF_WIDGET_STORE_ITEM_CONTENT_TEXT[layoutType]}자입니다.`;
};
